/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var OrganizationRequirementType;

(function (OrganizationRequirementType) {
  OrganizationRequirementType["COVERAGE"] = "coverage";
  OrganizationRequirementType["CURRENCY"] = "currency";
  OrganizationRequirementType["COUNTRY"] = "country";
})(OrganizationRequirementType || (OrganizationRequirementType = {}));